import GamesService from './GamesService'

let stack = [
    (window.location.pathname + window.location.search).replace('/casino', ''),
]
let modalStack = []

export default {
    setStack: (urlValue) => {
        let newStack = stack

        if (newStack.length >= 5) {
            newStack = [urlValue, ...newStack.slice(0, 9)]
        } else {
            newStack.unshift(urlValue)
        }
        stack = newStack
    },

    getStack: () => {
        return stack
    },

    getUrl() {
        let stack = this.getStack()

        if (stack.length > 0) {
            let validUrls = stack.filter((item) => {
                return !item.split('/').includes('game')
            })
            return validUrls.length > 0 ? validUrls[0] : '/'
        }

        return '/'
    },

    setModalStack: (modalName, url) => {
        modalStack = modalStack.filter((item) => item.modalName !== modalName)
        modalStack = [{ modalName, url }, ...modalStack]
    },
    getModalStack: () => modalStack,
    removeFromModalStack: (modalName) => {
        if (!modalName) {
            modalStack = []
        } else {
            modalStack = modalStack.filter(
                (item) => item.modalName !== modalName
            )
        }
    },
    redirectAfterLogin: (history) => {
        stack = stack.filter((el) => el !== '/log-ind')
        const urlHistory = stack

        const pendingGame = JSON.parse(localStorage.getItem('pendingGame'))

        if (pendingGame && Object.keys(pendingGame).length) {
            localStorage.removeItem('pendingGame')

            GamesService.pushGameToRecentlyPlayed(pendingGame)
            GamesService.checkLoginBeforeStart(pendingGame, history)
        } else {
            // Check if there's a game URL in the history stack (for backward compatibility)
            const gameUrl = urlHistory.find((url) => url.includes('/game/'))

            if (gameUrl) {
                // If there's a game URL, redirect to it
                history.push(gameUrl)
            } else if (
                urlHistory.length &&
                urlHistory[urlHistory.length - 1].indexOf('/konto') >= 0
            ) {
                // Otherwise, follow the original logic
                history.push(urlHistory[urlHistory.length - 1])
            }
        }
    },
}
